/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-new-wrappers */
/* eslint-disable no-loop-func */
import $ from 'jquery';
import Q from 'q';
import { EventEmitter } from 'Core';
import { SpinnerEventHandlerArgs } from 'Components';
import {
  IReportMeasurement,
  OptimizationType,
  UrlStateParameters,
  ReportKind,
  DispersionMode,
  OptimizerView,
  IReportMeasurementGroup,
  ISponsorReportInfo,
  ViewType,
  IReportVideo,
  IMeasurementReport,
  ISingleMeasurementParameter,
  GetSymbolUnitSystem,
  GetOptimizationTypesShorts,
  GetReportKind,
  GetDefaultOptimizedType,
  GetDispersionMode,
  GetOptimizerView,
  ClubTypeAbbreviationDictionary,
  GetViewType,
  INewestStroke,
} from 'Data';
import { IReportDataService } from 'Services';
import { GeneralReportStore, UrlHelper, MultiShotHelpers } from 'Reports';
import { action } from 'mobx';
import {
  OptimizationHelper,
  Parameter,
  GetParameter,
  ParameterHelper,
  UnitPresentation,
} from 'MeasurementsCalculations';
import { getNormalizationWithDefaultValuesIfEmpty, getReportInitialUrlParams } from 'utils';

export abstract class BaseReportHelpers {
  public static maxUrlLength: number;
  //public static spinner: Spinner;
  public static colorLibrary: Array<string>;

  static intilize() {
    //this.spinner = new Spinner();
    this.colorLibrary = [
      '#007AFF',
      '#FF2D55',
      '#9C27B0',
      '#FF9500',
      '#5856D6',
      '#946250',
      '#5AC8FA',
      '#FECC00',
      '#607D8B',
      '#4CAF50',
    ];
    this.maxUrlLength = 2000;
  }

  static isIOS() {
    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ];

    if (navigator?.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }

  static getDOMElementToMakeSureGraphicsWereRenderedBeforePrinting(
    reportKind: ReportKind
  ): string[] {
    switch (reportKind) {
      case ReportKind.testCenterReport:
        return ['summary-control'];
      case ReportKind.combineTestReport:
        return ['summary-control', '#dispersion-view-container', '#trajectory-container'];
      case ReportKind.compareReport:
        return ['#sideViewCanvas'];
      case ReportKind.singleShotReport:
        return ['#sideViewCanvas'];
      case ReportKind.multiGroupReport:
        return ['#sideViewCanvas'];
      case ReportKind.singleGroupReport:
        return ['#sideViewCanvas'];
      case ReportKind.puttingCompareReport:
        return ['skid-and-roll-control'];
      case ReportKind.puttingSingleShotReport:
        return ['skid-and-roll-control'];
      case ReportKind.puttingMultiGroupReport:
        return [];
      case ReportKind.puttingSingleGroupReport:
        return [];
      default:
        return [];
    }
  }

  static stringAsBoolean(input: string | boolean) {
    if (input === 'true' || input === true) return true;
    return false;
  }

  static getVideoImageToShare = (
    stroke: IReportMeasurement | undefined,
    reportKind: ReportKind
  ) => {
    let image = null;

    if (stroke) {
      const videos = stroke.videos ?? [];
      const otVideo = videos.filter(value => value.angle === 'OT');
      if (otVideo.length > 0) image = otVideo[0].posterUrl;
      else image = videos[0].posterUrl;
    }

    if (!image)
      if (reportKind === ReportKind.combineTestReport) {
        image =
          window.location.protocol +
          '//' +
          window.location.hostname +
          '/Renderers/DynamicReports/Images/' +
          'facebook_combine.png';
      } else {
        image =
          window.location.protocol +
          '//' +
          window.location.hostname +
          '/Renderers/DynamicReports/Images/' +
          'share_default_facebook_image.jpg';
      }
    return image;
  };

  static changeTilesToDisplay(newTiles: Array<string>, reportStore: GeneralReportStore): void {
    reportStore.tilesToDisplay = newTiles;
  }

  static deserializeStateFromUrl(currentReportStore: GeneralReportStore): GeneralReportStore {
    const reportStore = currentReportStore;
    const urlParameters = window.location.href.split('?')[1];
    const deparam: any = UrlHelper.getQueryStringAsObject(decodeURIComponent(urlParameters));

    if (deparam[UrlStateParameters.reportId]) {
      reportStore.reportId = deparam[UrlStateParameters.reportId].toLowerCase();
    }
    if (deparam['ReportId']) {
      reportStore.reportId = deparam['ReportId'].toLowerCase();
    }

    if (deparam[UrlStateParameters.optimizerOn]) {
      reportStore.optimizerOn = this.stringAsBoolean(deparam[UrlStateParameters.optimizerOn]);
    }

    if (deparam[UrlStateParameters.skidAndRollOn]) {
      reportStore.skidAndRollOn = this.stringAsBoolean(deparam[UrlStateParameters.skidAndRollOn]);
    }

    if (deparam[UrlStateParameters.dispersionOn]) {
      reportStore.dispersionOn = this.stringAsBoolean(deparam[UrlStateParameters.dispersionOn]);
    }

    if (deparam[UrlStateParameters.trajectoryOn]) {
      reportStore.trajectoryOn = this.stringAsBoolean(deparam[UrlStateParameters.trajectoryOn]);
    }

    if (deparam[UrlStateParameters.videoOn]) {
      reportStore.videoOn = this.stringAsBoolean(deparam[UrlStateParameters.videoOn]);
    }

    if (deparam[UrlStateParameters.clubDataOn]) {
      reportStore.clubDataOn = this.stringAsBoolean(deparam[UrlStateParameters.clubDataOn]);
    }

    if (deparam[UrlStateParameters.selectedDispersionMode]) {
      if (
        deparam[UrlStateParameters.selectedDispersionMode] ===
        UrlStateParameters.dispersionModeCarry
      ) {
        reportStore.selectedDispersionMode = DispersionMode.Carry;
      } else if (
        deparam[UrlStateParameters.selectedDispersionMode] ===
        UrlStateParameters.dispersionModeTotal
      ) {
        reportStore.selectedDispersionMode = DispersionMode.Total;
      }
    }

    // update normalization settings even if showNormalizedData is false (so user can show/hide normalized data with the same settings)
    const { normalization } = getReportInitialUrlParams();
    reportStore.normalizationSettings = normalization;
    //show normalized data - nd
    if (deparam[UrlStateParameters.showNormalizedData]) {
      reportStore.showNormalizedData = this.stringAsBoolean(
        deparam[UrlStateParameters.showNormalizedData]
      );
      this.changeStrokesAccordingToIsNormalized(reportStore);
    }

    // Selected optimized type - ot
    if (deparam[UrlStateParameters.selectedOptimizedType]) {
      reportStore.selectedOptimizedType = OptimizationType[
        deparam[UrlStateParameters.selectedOptimizedType]
      ] as any;
    }

    //Selected optimized type - ot
    if (deparam[UrlStateParameters.selectedOptimizerView]) {
      if (
        deparam[UrlStateParameters.selectedOptimizerView] === UrlStateParameters.optimizerViewData
      ) {
        reportStore.selectedOptimizerView = OptimizerView.Data;
      }
      if (
        deparam[UrlStateParameters.selectedOptimizerView] ===
        UrlStateParameters.optimizerViewTrajectory
      ) {
        reportStore.selectedOptimizerView = OptimizerView.Trajectory;
      }
    }

    //Tiles to display
    if (deparam[UrlStateParameters.measurementParameters]) {
      for (let i = 0; i < reportStore.measurementParameters.length; i++) {
        reportStore.measurementParameters[i].isVisible = false;
        for (let j = 0; j < deparam[UrlStateParameters.measurementParameters].length; j++) {
          if (
            reportStore.measurementParameters[i].propertyName ===
            deparam[UrlStateParameters.measurementParameters][j]
          ) {
            reportStore.measurementParameters[i].isVisible = true;
            break;
          }
        }
      }
    }

    // Groups of strokes
    if (
      deparam[UrlStateParameters.selectedGroupOfStrokes] &&
      deparam[UrlStateParameters.selectedGroupOfStrokes].length > 0
    ) {
      for (let j = 0; j < reportStore.measurementsData.length; j++) {
        reportStore.measurementsData[j].isSelected = false;
        for (let k = 0; k < deparam[UrlStateParameters.selectedGroupOfStrokes].length; k++) {
          if (
            reportStore.measurementsData[j].id.toLowerCase() ===
            deparam[UrlStateParameters.selectedGroupOfStrokes][k].toLowerCase()
          ) {
            reportStore.measurementsData[j].isSelected = true;
            break;
          }
        }
      }
      reportStore.selectedGroupOfStrokes = deparam[UrlStateParameters.selectedGroupOfStrokes];
    }

    //Selected unit
    if (deparam[UrlStateParameters.unitPresentation]) {
      reportStore.selectedUnit = deparam[UrlStateParameters.unitPresentation];
      reportStore.unitPresentation = new UnitPresentation(
        GetSymbolUnitSystem(reportStore.selectedUnit)
      );
    }

    //Selected view
    if (deparam[UrlStateParameters.selectedView]) {
      reportStore.selectedView = deparam[UrlStateParameters.selectedView];
      reportStore.unitPresentation = new UnitPresentation(
        GetSymbolUnitSystem(reportStore.selectedUnit)
      );
    }

    //Selected stroke
    if (deparam[UrlStateParameters.selectedStroke]) {
      for (let i = 0; i < reportStore.measurementsData.length; i++) {
        const strokes = reportStore.measurementsData[i].strokes ?? [];
        for (let j = 0; j < strokes.length; j++) {
          const stroke = strokes[j];
          if (
            stroke &&
            stroke.id &&
            stroke.id.toLowerCase() === deparam[UrlStateParameters.selectedStroke].toLowerCase()
          ) {
            reportStore.selectedStroke = strokes[j];
            break;
          }
        }
      }
    }

    //Selected group color- for coloring purposes - sgc
    if (deparam[UrlStateParameters.selectedGroupColor]) {
      for (let i = 0; i < reportStore.measurementsData.length; i++) {
        if (
          reportStore.measurementsData[i].id.toLowerCase() ===
          deparam[UrlStateParameters.selectedGroupColor].toLowerCase()
        ) {
          reportStore.selectedGroupOfStrokes = reportStore.measurementsData[i];
          break;
        }
      }
    }

    //Selected club type
    if (deparam[UrlStateParameters.selectedStrokeClub]) {
      if (reportStore.selectedGroupOfStrokes) {
        reportStore.clubType = reportStore.selectedGroupOfStrokes.clubType;
      }
    }

    //Hidden strokes
    if (deparam[UrlStateParameters.hiddenShots]) {
      for (let i = 0; i < deparam[UrlStateParameters.hiddenShots].length; i++) {
        const hiddenShot = deparam[UrlStateParameters.hiddenShots][i].toLowerCase();

        for (let j = 0; j < reportStore.measurementsData.length; j++) {
          const measurementGroup = reportStore.measurementsData[j];

          if (measurementGroup.strokes) {
            const strokes = measurementGroup.strokes.filter(x => x.id === hiddenShot);
            if (strokes.length > 0) {
              strokes[0].isVisible = false;
            }
          }

          if (measurementGroup.normalStrokes) {
            const normalStrokes = measurementGroup.normalStrokes.filter(x => x.id === hiddenShot);
            if (normalStrokes.length > 0) {
              normalStrokes[0].isVisible = false;
            }
          }

          if (measurementGroup.normalizedStrokes) {
            const normalizedStrokes = measurementGroup.normalizedStrokes.filter(
              x => x.id === hiddenShot
            );
            if (normalizedStrokes.length > 0) {
              normalizedStrokes[0].isVisible = false;
            }
          }
        }
      }

      //for (let i = 0; i < reportStore.measurementsData.length; i++) {
      //    for (let j = 0; j < reportStore.measurementsData[i].strokes.length; j++) {
      //        let stroke = reportStore.measurementsData[i].strokes[j];
      //        for (let k = 0; k < deparam[UrlStateParameters.hiddenShots].length; k++) {
      //            if (stroke.id.toLowerCase() ===
      //                deparam[UrlStateParameters.hiddenShots][k].toLowerCase().toLowerCase()) {
      //                stroke.isVisible = false;
      //            }
      //        }
      //    }
      //}
    }

    // Selected Video Angles
    if (deparam[UrlStateParameters.selectedVideoAngles]) {
      for (let i = 0; i < deparam[UrlStateParameters.selectedVideoAngles].length; i++) {
        const index = deparam[UrlStateParameters.selectedVideoAngles][i];
        let video = null;

        if (
          reportStore.reportKind === ReportKind.compareReport ||
          reportStore.reportKind === ReportKind.puttingCompareReport
        ) {
          const strokes = reportStore.measurementsData[i].strokes;
          const stroke = strokes && strokes[0];
          video = stroke && stroke.videos && stroke.videos[index];
        } else {
          const videos = reportStore.videos;
          video = videos && videos[index];
        }

        console.log('deserialize video', video);
        if (video) {
          if (reportStore.selectedVideos.length - 1 < i) {
            //was push null
            reportStore.selectedVideos = [];
          }
          reportStore.selectedVideos[i] = video;
        }
      }
    }

    // Selected average
    if (
      !deparam[UrlStateParameters.selectedStroke] &&
      deparam[UrlStateParameters.selectedGroupOfStrokes]
    ) {
      MultiShotHelpers.selectAverage(
        reportStore?.selectedGroupOfStrokes?.strokes ?? [],
        reportStore?.selectedGroupOfStrokes,
        reportStore
      );
    }

    if (deparam[UrlStateParameters.printVersion] !== undefined) {
      if (reportStore.showedPrintingDialog === false) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        reportStore.showedPrintingDialog = true;

        const loop = window.setInterval(function() {
          const elementToLookFor = self.getDOMElementToMakeSureGraphicsWereRenderedBeforePrinting(
            reportStore.reportKind
          );
          if (elementToLookFor === null) return;

          let hasDOMElements = true;
          for (let i = 0; i < elementToLookFor.length; i++) {
            hasDOMElements = hasDOMElements && $(elementToLookFor[i])[0] !== null;
          }

          if (hasDOMElements) {
            setTimeout(function() {
              window.print();
            }, 1000);
            window.clearInterval(loop);
          }
        }, 100);
      }
    }

    return reportStore;
  }

  static getPlayerName = (reportStore: GeneralReportStore) => {
    return reportStore.individualPlayers[0].name;
  };

  static shareOnFacebookOnClick(reportStore: GeneralReportStore) {
    let descriptionText = '';
    if (
      reportStore.reportKind === ReportKind.multiGroupReport ||
      reportStore.reportKind === ReportKind.singleGroupReport ||
      reportStore.reportKind === ReportKind.puttingMultiGroupReport ||
      reportStore.reportKind === ReportKind.puttingSingleGroupReport
    ) {
      if (reportStore.newestStrokeInfo && reportStore.newestStrokeInfo.player) {
        descriptionText = `Check out ${reportStore.newestStrokeInfo.player} latest report including numbers and all.`;
      } else {
        descriptionText = 'Check out the latest report including numbers and all.';
      }
    }
    if (
      reportStore.reportKind === ReportKind.combineTestReport ||
      reportStore.reportKind === ReportKind.testCenterReport
    ) {
      let myScoreText = '';
      if (
        reportStore.testResult !== null &&
        reportStore.testResult.statistics !== null &&
        reportStore.testResult.statistics.avgScore !== null
      ) {
        myScoreText = 'The score is ' + reportStore.testResult.statistics.avgScore + '.';
      }
      if (reportStore.newestStrokeInfo && reportStore.newestStrokeInfo.player) {
        descriptionText =
          'Check out ' +
          reportStore.newestStrokeInfo.player +
          ' Combine report including numbers and all. ' +
          myScoreText;
      } else {
        descriptionText = 'Check out the Combine report including numbers and all. ' + myScoreText;
      }
    }
    if (
      reportStore.reportKind === ReportKind.compareReport ||
      reportStore.reportKind === ReportKind.puttingCompareReport
    ) {
      const playerOne = reportStore.newestStrokeInfo && reportStore.newestStrokeInfo.player;
      const playerTwo =
        playerOne === reportStore.individualPlayers[0].name
          ? reportStore.individualPlayers[1].name
          : reportStore.individualPlayers[0].name;
      if (playerOne && playerOne !== '' && playerTwo && playerTwo !== '') {
        descriptionText =
          'Check out ' +
          playerOne +
          ' latest report including numbers and all compared with ' +
          playerTwo;
      } else {
        descriptionText = 'Check out the latest report including numbers and all.';
      }
    }
    if (
      reportStore.reportKind === ReportKind.singleShotReport ||
      reportStore.reportKind === ReportKind.puttingSingleShotReport
    ) {
      const playerName = this.getPlayerName(reportStore);
      if (playerName && playerName !== '') {
        descriptionText = 'Check out ' + playerName + ' latest report including numbers and all.';
      } else {
        descriptionText = 'Check out the latest report including numbers and all.';
      }
    }

    const params = {
      method: 'share_open_graph',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object: {
          'og:url': reportStore.shareLink,
          'og:title': 'TrackMan Golf',
          'og:description': descriptionText,
          'og:image': reportStore.reportImage,
        },
      }),
    };

    (window as any).FB.ui(params, (response: any) => {
      console.log(response);
    });
  }

  static shareOnTwitterOnClick = (reportStore: GeneralReportStore) => {
    const twitterBaseUrl = 'https://twitter.com/intent/tweet?';
    let tweetText = '';
    if (
      reportStore.reportKind === ReportKind.multiGroupReport ||
      reportStore.reportKind === ReportKind.singleGroupReport
    ) {
      tweetText = 'Check out my latest shots from @TrackManGolf';
    }
    if (
      reportStore.reportKind === ReportKind.puttingMultiGroupReport ||
      reportStore.reportKind === ReportKind.puttingSingleGroupReport
    ) {
      tweetText = 'Check out my latest putts from @TrackManGolf';
    }
    if (
      reportStore.reportKind === ReportKind.combineTestReport ||
      reportStore.reportKind === ReportKind.testCenterReport
    ) {
      tweetText = 'Check out my latest Combine Score';
    }
    if (reportStore.reportKind === ReportKind.compareReport) {
      tweetText = 'See my @TrackManGolf shots';
    }
    if (reportStore.reportKind === ReportKind.puttingCompareReport) {
      tweetText = 'See my @TrackManGolf putts';
    }
    if (reportStore.reportKind === ReportKind.singleShotReport) {
      tweetText = 'Check out my latest shot from @TrackManGolf';
    }
    if (reportStore.reportKind === ReportKind.puttingSingleShotReport) {
      tweetText = 'Check out my latest putt from @TrackManGolf';
    }
    const url = reportStore.shareLink;
    const hashtag = '';
    const twitterFullUrl = `${twitterBaseUrl}text=${encodeURI(
      tweetText
    )}&url=${url}&hashtags=${hashtag}`;

    window.open(
      twitterFullUrl,
      'mywindow',
      'menubar=1,scrollbars=no,resizable=1,width=375,height=480'
    );
  };

  static onClickMailButton(reportStore: GeneralReportStore) {
    const emailAdressesToSendReport = '';
    const subject = 'TrackMan Report';
    const body = 'Check out the link to your report';
    const fullMailToUrl = `mailto:${encodeURI(
      emailAdressesToSendReport + '?subject=' + subject + '&body=' + body
    )}%0D%0A${encodeURI(reportStore.shareLink)}`;
    window.location.href = fullMailToUrl;
  }

  static serializeStateToUrlQuery(reportStore: GeneralReportStore): string {
    const obj: any = {};

    if (reportStore.reportId) {
      obj[UrlStateParameters.reportId] = reportStore.reportId;
    }

    if (reportStore.selectedDispersionMode) {
      if (reportStore.selectedDispersionMode === DispersionMode.Carry) {
        obj[UrlStateParameters.selectedDispersionMode] = UrlStateParameters.dispersionModeCarry;
      } else if (reportStore.selectedDispersionMode === DispersionMode.Total) {
        obj[UrlStateParameters.selectedDispersionMode] = UrlStateParameters.dispersionModeTotal;
      }
    }

    obj[UrlStateParameters.showNormalizedData] = reportStore.showNormalizedData;
    const normalizationSettingsWithDefaultValues = getNormalizationWithDefaultValuesIfEmpty(
      reportStore.normalizationSettings ?? {}
    );
    obj[UrlStateParameters.ballType] = normalizationSettingsWithDefaultValues.ballType;
    obj[UrlStateParameters.altitude] = normalizationSettingsWithDefaultValues.altitude;
    obj[UrlStateParameters.temperature] = normalizationSettingsWithDefaultValues.temperature;
    obj[UrlStateParameters.altitudeUnit] = normalizationSettingsWithDefaultValues.altitudeUnit;
    obj[UrlStateParameters.temperatureUnit] =
      normalizationSettingsWithDefaultValues.temperatureUnit;

    obj[UrlStateParameters.optimizerOn] = reportStore.optimizerOn;

    obj[UrlStateParameters.skidAndRollOn] = reportStore.skidAndRollOn;

    obj[UrlStateParameters.dispersionOn] = reportStore.dispersionOn;

    obj[UrlStateParameters.trajectoryOn] = reportStore.trajectoryOn;

    obj[UrlStateParameters.videoOn] = reportStore.videoOn;

    obj[UrlStateParameters.clubDataOn] = reportStore.clubDataOn;

    if (reportStore.selectedOptimizedType) {
      obj[UrlStateParameters.selectedOptimizedType] = GetOptimizationTypesShorts(
        reportStore.selectedOptimizedType.value
      );
    }

    if (reportStore.selectedOptimizerView) {
      if (reportStore.selectedOptimizerView === OptimizerView.Data) {
        obj[UrlStateParameters.selectedOptimizerView] = UrlStateParameters.optimizerViewData;
      } else if (reportStore.selectedOptimizerView === OptimizerView.Trajectory) {
        obj[UrlStateParameters.selectedOptimizerView] = UrlStateParameters.optimizerViewTrajectory;
      }
    }

    //Tiles to display
    if (reportStore.measurementParameters) {
      obj[UrlStateParameters.measurementParameters] = [];
      for (let i = 0; i < reportStore.measurementParameters.length; i++) {
        if (reportStore.measurementParameters[i].isVisible) {
          obj[UrlStateParameters.measurementParameters].push(
            reportStore.measurementParameters[i].propertyName
          );
        }
      }
    }

    if (reportStore.unitPresentation) {
      //todo check if selected unit is used besides in serialization and reading url
      obj[UrlStateParameters.unitPresentation] = reportStore.selectedUnit;
      //reportStore.unitPresentation = new UnitPresentation(SymbolUnitSystem[reportStore.selectedUnit]);
    }

    if (reportStore.selectedView) {
      obj[UrlStateParameters.selectedView] = reportStore.selectedView;
    }

    if (reportStore.selectedStroke) {
      obj[UrlStateParameters.selectedStroke] = reportStore.selectedStroke.id;
    }

    obj[UrlStateParameters.selectedGroupOfStrokes] = [];

    for (let i = 0; i < reportStore.measurementsData.length; i++) {
      const group = reportStore.measurementsData[i];
      if (group.isSelected) {
        obj[UrlStateParameters.selectedGroupOfStrokes].push(group.id);
      }
    }

    //Selected group color- for coloring purposes - sgc
    if (reportStore.selectedGroupOfStrokes) {
      obj[UrlStateParameters.selectedGroupColor] = reportStore.selectedGroupOfStrokes.id;
    }

    if (reportStore.selectedStroke) {
      obj[UrlStateParameters.selectedStrokeClub] = reportStore.clubType;
    }

    obj[UrlStateParameters.hiddenShots] = reportStore.hiddenStrokes.slice();

    obj[UrlStateParameters.selectedVideoAngles] = [];
    for (let i = 0; i < reportStore.selectedVideos.length; i++) {
      const selectedVideo = reportStore.selectedVideos[i];
      if (selectedVideo) {
        let index = 0;

        if (
          reportStore.reportKind === ReportKind.compareReport ||
          reportStore.reportKind === ReportKind.puttingCompareReport
        ) {
          const md = reportStore.measurementsData && reportStore.measurementsData[i];
          const stroke = md && md.strokes && md.strokes[0];
          index = stroke?.videos?.indexOf(selectedVideo) ?? 0;
        } else {
          index = reportStore.videos?.indexOf(selectedVideo) ?? 0;
        }

        if (index >= 0) {
          obj[UrlStateParameters.selectedVideoAngles][i] = index;
        }
      }
    }
    let str = $.param(obj);

    // reduce length of url parameters
    const newUrl = window.location.pathname + '?' + str;
    if (newUrl.length > this.maxUrlLength) {
      const maxStrLength = this.maxUrlLength - window.location.pathname.length - 1;
      const lastParameter = str.lastIndexOf('&', maxStrLength);
      str = str.slice(0, lastParameter);
    }
    return str;
  }

  static defaultNormalizedOrNotNormalizedData(
    reportKind: ReportKind,
    group: IReportMeasurementGroup,
    showNormalizedData: boolean
  ): Array<IReportMeasurement> {
    if (showNormalizedData) {
      return group.normalizedStrokes;
    } else {
      return group.normalStrokes;
    }
  }

  static loadDataToState(
    reportDataService: IReportDataService,
    reportStore: GeneralReportStore,
    spinnerEventHandler: EventEmitter<Record<string, any>, SpinnerEventHandlerArgs>
  ): Q.Promise<[IMeasurementReport, boolean]> {
    const getReportPromise = reportDataService.getReportData(reportStore.reportId);
    getReportPromise.done(
      action('dataLoaded', (result: [IMeasurementReport, boolean]) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [data, deviceOnline] = result; //= let data = result[0], device = result []

        if (!reportStore.reportId) {
          reportStore.reportId = data.id;
        }
        const groups = data.groups;
        if (reportStore.reportKind === ReportKind.combineTestReport) {
          if (groups.filter(x => x.normalStrokes.length !== 0).length === 0) {
            reportStore.noStrokes = true;
            return;
          }
        } else {
          if (
            groups.filter(x => x.normalizedStrokes.length !== 0 || x.normalStrokes.length !== 0)
              .length === 0
          ) {
            reportStore.noStrokes = true;
            return;
          }
        }

        reportStore.reportKind = GetReportKind(data.kind);
        this.setInitialViewValues(reportStore);
        this.setDocumentTitle(reportStore.reportKind);

        if (
          reportStore.reportKind === ReportKind.singleShotReport ||
          reportStore.reportKind === ReportKind.puttingSingleShotReport
        ) {
          data.settings.selectedStroke = data.groups[0]?.normalStrokes[0]?.id;
          data.settings.selectedGroupOfStrokes = data.groups[0].id;
          data.settings.selectedClubType = data.groups[0].clubType;
        }
        const selectedOptimizedType =
          data.settings?.selectedOptimizedType && data.settings.selectedOptimizedType
            ? GetDefaultOptimizedType(
                data.settings.selectedOptimizedType.charAt(0).toUpperCase() +
                  data.settings.selectedOptimizedType.slice(1)
              )
            : reportStore.selectedOptimizedType;

        reportStore.reportDate = !data.time ? reportStore.reportDate : data.time;
        reportStore.sponsors = !data.sponsors
          ? reportStore.sponsors
          : (data.sponsors as ISponsorReportInfo[]);
        reportStore.normalizedEnvironmentDetails = !data.environment
          ? reportStore.normalizedEnvironmentDetails
          : data.environment;
        reportStore.facilities = !data.facilities ? reportStore.facilities : data.facilities;
        if (
          reportStore.reportKind !== ReportKind.combineTestReport &&
          reportStore.reportKind !== ReportKind.testCenterReport
        ) {
          reportStore.selectedUnit =
            data.settings && data.settings.units ? data.settings.units : reportStore.selectedUnit;
        } else {
          reportStore.selectedUnit =
            data !== null && data.testResult !== null && data.testResult.definition.inYards !== null
              ? data.testResult.definition.inYards
                ? 'u'
                : 'e'
              : reportStore.selectedUnit;
        }

        reportStore.unitPresentation = new UnitPresentation(
          GetSymbolUnitSystem(reportStore.selectedUnit)
        );

        reportStore.summaryOn =
          data?.settings?.summaryOn === undefined || data?.settings?.summaryOn === null
            ? reportStore.summaryOn
            : data.settings.summaryOn;
        reportStore.optimizerOn =
          data?.settings?.optimizerOn === undefined || data?.settings?.optimizerOn === null
            ? reportStore.optimizerOn
            : data.settings.optimizerOn;
        reportStore.skidAndRollOn =
          data?.settings?.skidAndRollOn === undefined || data?.settings?.skidAndRollOn === null
            ? reportStore.skidAndRollOn
            : data.settings.skidAndRollOn;
        reportStore.dispersionOn =
          data?.settings?.dispersionOn === undefined || data?.settings?.dispersionOn === null
            ? reportStore.dispersionOn
            : data.settings.dispersionOn;
        reportStore.trajectoryOn =
          data?.settings?.trajectoryOn === undefined || data?.settings?.trajectoryOn === null
            ? reportStore.trajectoryOn
            : data.settings.trajectoryOn;
        reportStore.videoOn =
          data?.settings?.videoOn === undefined || data?.settings?.videoOn === null
            ? reportStore.videoOn
            : data.settings.videoOn;
        reportStore.clubDataOn =
          data?.settings?.clubDataOn === undefined || data?.settings?.clubDataOn === null
            ? reportStore.clubDataOn
            : data.settings.clubDataOn;
        reportStore.isTps =
          data?.settings?.isTps === undefined || data?.settings?.isTps === null
            ? reportStore.isTps
            : data.settings.isTps;
        reportStore.isIos =
          data?.settings?.isIos === undefined || data?.settings?.isIos === null
            ? reportStore.isIos
            : data.settings.isIos;
        reportStore.isWeb =
          data?.settings?.isWeb === undefined || data?.settings?.isWeb === null
            ? reportStore.isWeb
            : data.settings.isWeb;
        reportStore.instructorMessage = !data?.settings?.instructorMessage
          ? reportStore.instructorMessage
          : data.settings.instructorMessage;
        reportStore.reportSelection = !data?.settings?.reportSelection
          ? reportStore.reportSelection
          : data.settings.reportSelection;
        reportStore.selectedDispersionMode =
          !data?.settings?.selectedDispersionMode ||
          data.settings.selectedDispersionMode === DispersionMode.NotDefined
            ? reportStore.selectedDispersionMode
            : GetDispersionMode(data.settings.selectedDispersionMode);
        reportStore.showNormalizedData =
          data?.settings?.showNormalizedData === undefined ||
          data?.settings?.showNormalizedData === null
            ? reportStore.showNormalizedData
            : data.settings.showNormalizedData;
        reportStore.selectedOptimizedType = selectedOptimizedType;
        reportStore.selectedOptimizerView = !data?.settings?.selectedOptimizerView
          ? reportStore.selectedOptimizerView
          : GetOptimizerView(data.settings.selectedOptimizerView);
        reportStore.clubType = !data.settings?.selectedClubType
          ? reportStore.clubType
          : data.settings.selectedClubType; // todo to enum
        reportStore.showBottomCommercial =
          data.settings?.showBottomCommercial === undefined ||
          data.settings?.showBottomCommercial === null
            ? reportStore.showBottomCommercial
            : data.settings.showBottomCommercial;
        reportStore.siteName = !data.settings?.drivingRangeSettings?.siteName
          ? reportStore.siteName
          : data.settings.drivingRangeSettings.siteName;
        reportStore.siteShortName = !data.settings?.drivingRangeSettings?.siteName
          ? reportStore.siteShortName
          : data.settings.drivingRangeSettings.siteShortName;
        reportStore.instructorName = !data.user.name ? reportStore.instructorName : data.user.name;
        reportStore.instructorImage = !data.user.image
          ? reportStore.instructorImage
          : data.user.image;
        reportStore.instructorId = !data.user.id ? reportStore.instructorId : data.user.id;
        if (data.settings?.tiles) {
          if (data.settings.tiles.length > 10) {
            for (let i = 0; i < 10; i++) {
              reportStore.tilesToDisplay.push(data.settings.tiles[i]);
            }
          } else {
            for (let i = 0; i < data.settings.tiles.length; i++) {
              reportStore.tilesToDisplay.push(data.settings.tiles[i]);
            }
          }
        }
        console.log('reportStore.tilesToDisplay', reportStore.tilesToDisplay);
        if (reportStore.measurementsData !== null) {
          for (let i = 0; i < groups.length; i++) {
            groups[i].isSelected = true;
            if (
              data.settings?.selectedStrokesGroups &&
              data.settings.selectedStrokesGroups.length !== 0
            ) {
              groups[i].isSelected =
                data.settings.selectedStrokesGroups.filter(group => group === groups[i].id).length >
                0;
            }
            groups[i].isCollapsed = false;
            groups[i].color = this.colorLibrary[i % this.colorLibrary.length];
            groups[i].abbreviatedClubType = ClubTypeAbbreviationDictionary[groups[i].clubType];
            let tagsTitle = '';
            for (let j = 0; j < groups[i].tags.length; j++) {
              tagsTitle += groups[i].tags[j] + ' ';
            }
            groups[i].tagsTitle = tagsTitle;

            const max =
              reportStore.reportKind !== ReportKind.combineTestReport
                ? Math.max(groups[i].normalizedStrokes.length, groups[i].normalStrokes.length)
                : groups[i].normalStrokes.length;

            for (let j = 0; j < max; j++) {
              let hasVideos = false;
              let isVisible = true;
              let canOptimize = false;
              if (reportStore.reportKind !== ReportKind.combineTestReport) {
                if (
                  groups[i].normalizedStrokes &&
                  groups[i].normalizedStrokes.length !== 0 &&
                  groups[i].normalizedStrokes.length >= j - 1
                ) {
                  if (j < groups[i].normalizedStrokes.length) {
                    if (groups[i].normalizedStrokes[j].id === data.settings?.selectedStroke) {
                      reportStore.selectedStroke = groups[i].normalizedStrokes[j];
                    }

                    const normalizedStroke = groups[i].normalizedStrokes[j];
                    canOptimize = OptimizationHelper.strokeCanBeOptimized(normalizedStroke);

                    if (
                      data.settings?.hiddenShots !== undefined &&
                      data.settings.hiddenShots.length !== 0
                    ) {
                      isVisible =
                        data.settings.hiddenShots.filter(x => x === normalizedStroke.id).length ===
                        0;
                    }

                    normalizedStroke.isVisible = isVisible;
                    normalizedStroke.canOptimize = canOptimize;

                    if (normalizedStroke.videos) {
                      for (let k = 0; k < normalizedStroke.videos.length; k++) {
                        const selectedVideoSpeedRate = 0;
                        normalizedStroke.videos[k].selectedVideoSpeedRate = selectedVideoSpeedRate;
                        if (hasVideos === false && normalizedStroke.videos[k].url) {
                          hasVideos = true;
                          reportStore.reportHasAtLeastOneVideo = true;
                        }
                      }
                      normalizedStroke.hasVideos = hasVideos;
                    }
                  }
                }
              }

              if (j < groups[i].normalStrokes.length) {
                if (
                  groups[i].normalStrokes &&
                  groups[i].normalStrokes.length !== 0 &&
                  groups[i].normalStrokes.length >= j - 1
                ) {
                  if (groups[i].normalStrokes[j].id === data.settings?.selectedStroke) {
                    reportStore.selectedStroke = groups[i].normalStrokes[j];
                  }

                  const normalStroke = groups[i].normalStrokes[j];
                  canOptimize = OptimizationHelper.strokeCanBeOptimized(normalStroke);

                  if (data.settings?.hiddenShots && data.settings.hiddenShots.length !== 0) {
                    isVisible =
                      data.settings.hiddenShots.filter(x => x === normalStroke.id).length === 0;
                  }

                  normalStroke.isVisible = isVisible;
                  normalStroke.canOptimize = canOptimize;

                  if (normalStroke.videos) {
                    for (let k = 0; k < normalStroke.videos.length; k++) {
                      const selectedVideoSpeedRate = 0;
                      normalStroke.videos[k].selectedVideoSpeedRate = selectedVideoSpeedRate;
                      if (hasVideos === false && normalStroke.videos[k].url) {
                        hasVideos = true;
                        reportStore.reportHasAtLeastOneVideo = true;
                      }
                    }
                    normalStroke.hasVideos = hasVideos;
                  }
                }
              }
            }
            groups[i].strokes = this.defaultNormalizedOrNotNormalizedData(
              reportStore.reportKind,
              groups[i],
              reportStore.showNormalizedData
            );
            if (groups[i].id === data.settings?.selectedGroupOfStrokes) {
              reportStore.selectedGroupOfStrokes = groups[i];
              if (!reportStore.selectedStroke) {
                const storkes = reportStore.selectedGroupOfStrokes.strokes ?? [];
                MultiShotHelpers.selectAverage(
                  storkes.filter(strokes => strokes.isVisible),
                  reportStore.selectedGroupOfStrokes,
                  reportStore
                );
              }
            }

            if (i === 0) {
              if (groups[i] && groups[i].player) {
                reportStore.individualPlayers.push(groups[i]?.player);
              }
            } else {
              if (
                reportStore.individualPlayers.filter(
                  x => x.id === (groups[i] && groups[i].player && groups[i].player?.id)
                ).length === 0
              ) {
                reportStore.individualPlayers.push(groups[i]?.player);
              }
            }
          }
          reportStore.measurementsData = groups;
        }
        const selectedView = data.settings?.selectedView
          ? GetViewType(
              data.settings.selectedView.charAt(0).toUpperCase() +
                data.settings.selectedView.slice(1)
            )
          : this.checkInitiallyDisplayedView(reportStore);
        reportStore.selectedView = selectedView;
        if (reportStore.isWeb) {
          reportStore.newestStrokeInfo = this.getNewestStrokeInfo(reportStore);
          reportStore.reportImage = this.getVideoImageToShare(
            reportStore.newestStrokeInfo.stroke,
            reportStore.reportKind
          );
        }
        if (data.settings?.selectedVideoAngles && data.settings.selectedVideoAngles.length !== 0) {
          const selectedVideos = [];
          for (let i = 0; i < data.settings.selectedVideoAngles.length; i++) {
            const index = data.settings.selectedVideoAngles[i];
            const video = reportStore.videos && reportStore.videos[index];
            if (video) {
              if (selectedVideos.length - 1 < i) {
                selectedVideos.push(null);
                console.log('selectedVideos in');
              }
              reportStore.selectedVideos[i] = video;
            }
          }
        }
        reportStore.showReport = true;
        spinnerEventHandler.emit(this, { hideSpinner: true });
        this.changeStrokesAccordingToIsNormalized(reportStore);
      })
    );

    return getReportPromise;
  }

  private static getNewestStrokeInfo = (reportStore: GeneralReportStore) => {
    let newestStroke;
    let playerName;

    for (let i = 0; i < reportStore.measurementsData.length; i++) {
      const group = reportStore.measurementsData[i];
      const strokes = (group && group.strokes) ?? [];
      for (let j = 0; j < strokes.length; j++) {
        const stroke = strokes[j];
        const relevantVideos = stroke.videos ? stroke.videos.filter(x => x.posterUrl !== '') : [];
        if (relevantVideos.length > 0) {
          if (
            !newestStroke ||
            (stroke &&
              stroke.time &&
              newestStroke &&
              newestStroke.time &&
              stroke.time > newestStroke.time)
          ) {
            newestStroke = stroke;
            playerName = group.player?.name ?? '';
          }
        }
      }
    }

    return { player: playerName, stroke: newestStroke } as INewestStroke;
  };

  public static changeToEditMode(reportStore: GeneralReportStore) {
    reportStore.editModeInTps = !reportStore.editModeInTps;
    reportStore.selectedView = this.checkInitiallyDisplayedView(reportStore);
  }

  public static setDocumentTitle(reportKind: ReportKind) {
    switch (reportKind) {
      case ReportKind.multiGroupReport:
        document.title = 'Multi group report';
        break;
      case ReportKind.singleGroupReport:
        document.title = 'Single group report';
        break;
      case ReportKind.puttingMultiGroupReport:
        document.title = 'Putting multi group report';
        break;
      case ReportKind.puttingSingleGroupReport:
        document.title = 'Putting single group report';
        break;
      case ReportKind.singleShotReport:
        document.title = 'Single shot report';
        break;
      case ReportKind.puttingSingleShotReport:
        document.title = 'Putting single shot report';
        break;
      case ReportKind.compareReport:
        document.title = 'Compare report';
        break;
      case ReportKind.puttingCompareReport:
        document.title = 'Putting compare report';
        break;
      case ReportKind.testCenterReport:
        document.title = 'Test Center report';
        break;
      case ReportKind.combineTestReport:
        document.title = 'Combine report';
        break;
      default:
        console.debug('Missing report kind in setDocumentTitle', reportKind);
        break;
    }
  }

  private static checkInitiallyDisplayedView(reportStore: GeneralReportStore): ViewType {
    switch (reportStore.reportKind) {
      case ReportKind.multiGroupReport:
      case ReportKind.singleGroupReport:
        if (reportStore.dispersionOn) {
          return (reportStore.selectedView = ViewType.Dispersion);
        } else if (reportStore.trajectoryOn) {
          return (reportStore.selectedView = ViewType.Trajectory);
        } else if (reportStore.optimizerOn) {
          return (reportStore.selectedView = ViewType.Optimizer);
        } else if (reportStore.clubDataOn) {
          return (reportStore.selectedView = ViewType.ClubData);
        } else if (reportStore.videoOn && reportStore.reportHasAtLeastOneVideo) {
          return (reportStore.selectedView = ViewType.Video);
        }
        break;
      case ReportKind.combineTestReport:
      case ReportKind.testCenterReport:
        if (reportStore.summaryOn) {
          return (reportStore.selectedView = ViewType.Summary);
        } else if (reportStore.dispersionOn) {
          return (reportStore.selectedView = ViewType.Dispersion);
        } else if (reportStore.trajectoryOn) {
          return (reportStore.selectedView = ViewType.Trajectory);
        } else if (reportStore.clubDataOn) {
          return (reportStore.selectedView = ViewType.ClubData);
        }
        break;
      case ReportKind.singleShotReport:
        if (reportStore.videoOn && reportStore.reportHasAtLeastOneVideo) {
          return (reportStore.selectedView = ViewType.Video);
        } else if (reportStore.trajectoryOn) {
          return (reportStore.selectedView = ViewType.Trajectory);
        } else if (reportStore.optimizerOn) {
          return (reportStore.selectedView = ViewType.Optimizer);
        } else if (reportStore.clubDataOn) {
          return (reportStore.selectedView = ViewType.ClubData);
        }
        break;
      case ReportKind.compareReport:
        if (reportStore.videoOn) {
          return (reportStore.selectedView = ViewType.Video);
        } else if (reportStore.trajectoryOn) {
          return (reportStore.selectedView = ViewType.Trajectory);
        }
        break;
      case ReportKind.puttingMultiGroupReport:
      case ReportKind.puttingSingleGroupReport:
      case ReportKind.puttingSingleShotReport:
      case ReportKind.puttingCompareReport:
        if (reportStore.videoOn) {
          return (reportStore.selectedView = ViewType.Video);
        } else if (reportStore.skidAndRollOn) {
          return (reportStore.selectedView = ViewType.SkidAndRoll);
        }
    }
    return ViewType.NotSpecified;
  }

  public static toggleTab(reportStore: GeneralReportStore, tab: string) {
    (reportStore as any)[tab] = !(reportStore as any)[tab];
    (reportStore as any)[tab] = (reportStore as any)[tab];
  }

  public static checkIfOptimizerTutorialShouldBeShown(): boolean {
    const showOptimizerTutorial = new Boolean(localStorage['DontShowOptimizerTutorial']);
    return !showOptimizerTutorial.valueOf();
  }

  public static setToDontShowOptimizerTutorial() {
    localStorage['DontShowOptimizerTutorial'] = true;
  }

  public static toggleCommercial(reportStore: GeneralReportStore) {
    reportStore.showBottomCommercial = !reportStore.showBottomCommercial;
  }

  public static selectView(view: ViewType, reportStore: GeneralReportStore) {
    reportStore.selectedView = view;
  }

  public static displayStrokesGroup(index: number, reportStore: GeneralReportStore, _tps: any) {
    if (reportStore.measurementsData[index].isSelected) {
      if (reportStore.selectedGroupOfStrokes) {
        if (reportStore.measurementsData[index] === reportStore.selectedGroupOfStrokes) {
          reportStore.selectedGroupOfStrokes = undefined;
          reportStore.selectedAverage = undefined;
          reportStore.selectedStroke = undefined;
        }
      }

      reportStore.measurementsData[index].isSelected = false;
    } else {
      reportStore.measurementsData[index].isSelected = true;
    }
  }

  public static onSelectedVideosChanged(videos: IReportVideo[], reportStore: GeneralReportStore) {
    const observableVideos = videos;
    reportStore.selectedVideos = observableVideos;
  }

  static tryReadReportIdFromUrl(): string {
    const urlParameters =
      window && window.location && window.location.href && window.location.href.split('?')[1];
    const deparam = this.deparam(urlParameters);

    if ((deparam as any)[UrlStateParameters.reportId]) {
      return (deparam as any)[UrlStateParameters.reportId].toLowerCase();
    }
    if ((deparam as any)['ReportId']) {
      return (deparam as any)['ReportId'].toLowerCase();
    }

    return '';
  }

  public static NewGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public static deparam(uri?: any) {
    console.log('uri', uri);
    if (uri === undefined) {
      uri = window.location.search;
    }
    const queryString = {};
    uri.replace(new RegExp('([^?=&]+)(=([^&#]*))?', 'g'), ($0: any, $1: any, $2: any, $3: any) => {
      (queryString as any)[$1] = $3;
    });
    console.log('queryString', queryString);
    return queryString;
  }

  static loadTiles(reportStore: GeneralReportStore) {
    if (reportStore.measurementsData !== null) {
      if (reportStore.measurementsData.length > 0) {
        let visibleCount = 0;

        // First add the score (1st column)
        if (
          reportStore.reportKind === ReportKind.combineTestReport ||
          reportStore.reportKind === ReportKind.testCenterReport
        ) {
          if (BaseReportHelpers.addTile('Score', visibleCount, reportStore)) visibleCount++;
        }

        for (let i = 0; i < reportStore.tilesToDisplay.length; i++) {
          if (BaseReportHelpers.addTile(reportStore.tilesToDisplay[i], visibleCount, reportStore)) {
            visibleCount++;
          }
        }

        const md = reportStore.measurementsData && reportStore.measurementsData[0];
        const stroke = md && md.strokes && md.strokes[0];
        if (stroke) {
          for (const param in stroke) {
            if (BaseReportHelpers.addTile(param, visibleCount, reportStore)) {
              visibleCount++;
            }
          }
        }
      }
    }
  }

  static addTile(param: string, visibleCount: number, reportStore: GeneralReportStore): boolean {
    const paramPascalCase = ParameterHelper.firstLetterToUpperCase(param);
    const parameter = GetParameter(paramPascalCase);
    if (
      reportStore.measurementParameters &&
      parameter !== Parameter.Undefined &&
      reportStore.measurementParameters.filter(x => x.propertyName === paramPascalCase).length === 0
    ) {
      let isVisible = false;
      isVisible = visibleCount < 10 && reportStore.tilesToDisplay.indexOf(paramPascalCase) >= 0;
      const measurementParameter: ISingleMeasurementParameter = {
        propertyName: paramPascalCase,
        title: reportStore.unitPresentation.title(parameter),
        displayUnit: reportStore.unitPresentation.displayUnit(parameter),
        isVisible: isVisible,
        myTrackManPage: ParameterHelper.getParameterLink(paramPascalCase),
      };

      measurementParameter.isSelected = false;

      reportStore.measurementParameters.push(measurementParameter);
    }
    return true;
  }

  static updateUnitOnTiles(reportStore: GeneralReportStore) {
    if (reportStore.measurementParameters !== null) {
      for (let i = 0; i < reportStore.measurementParameters.length; i++) {
        const param = reportStore.measurementParameters[i];
        const parameter = GetParameter(param.propertyName);
        param.title = reportStore.unitPresentation.title(parameter);
        param.displayUnit = reportStore.unitPresentation.displayUnit(parameter);
      }
    }
  }

  static changeStrokesAccordingToIsNormalized(generalReportStore: GeneralReportStore) {
    generalReportStore.measurementsData.forEach(g => {
      //g.strokes = generalReportStore.showNormalizedData ? g.normalStrokes : g.normalizedStrokes;
      if (
        generalReportStore.showNormalizedData &&
        g.normalizedStrokes !== undefined &&
        g.normalizedStrokes.length
      ) {
        g.strokes = g.normalizedStrokes;
      } else {
        g.strokes = g.normalStrokes;
      }
      g.strokes.forEach(s => {
        if (generalReportStore.selectedStroke && s.id === generalReportStore.selectedStroke.id) {
          generalReportStore.selectedStroke = s;
        }
      });
    });
  }

  static setInitialViewValues(reportStore: GeneralReportStore) {
    switch (reportStore.reportKind) {
      case ReportKind.multiGroupReport:
      case ReportKind.singleGroupReport:
        reportStore.dispersionOn = true;
        reportStore.trajectoryOn = true;
        reportStore.optimizerOn = true;
        reportStore.clubDataOn = true;
        reportStore.videoOn = true;
        break;
      case ReportKind.combineTestReport:
      case ReportKind.testCenterReport:
        reportStore.summaryOn = true;
        reportStore.dispersionOn = true;
        reportStore.trajectoryOn = true;
        reportStore.clubDataOn = true;
        break;
      case ReportKind.singleShotReport:
        reportStore.videoOn = true;
        reportStore.trajectoryOn = true;
        reportStore.optimizerOn = true;
        reportStore.clubDataOn = true;
        break;
      case ReportKind.compareReport:
        reportStore.videoOn = true;
        reportStore.trajectoryOn = true;
        break;
      case ReportKind.puttingSingleShotReport:
      case ReportKind.puttingMultiGroupReport:
      case ReportKind.puttingSingleGroupReport:
      case ReportKind.puttingCompareReport:
        reportStore.videoOn = true;
        reportStore.skidAndRollOn = true;
        break;
    }
  }
}

BaseReportHelpers.intilize();
